var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDnIconGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.40147 1.34614C2.14132 1.61248 2 2.01835 2 2.55421V21.4553C2 21.9785 2.15417 22.3971 2.40147 22.6507L2.47213 22.7078L13.1995 12.1078V11.8668L2.4625 1.28906L2.40147 1.34614Z",
    fill: "url(#paint0_linear_15481_159735)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.77 15.6617L13.1953 12.1326V11.8885L16.77 8.35938L16.8535 8.40694L21.0866 10.7882C22.2975 11.4604 22.2975 12.5765 21.0866 13.2614L16.8535 15.6395L16.77 15.6617Z",
    fill: "url(#paint1_linear_15481_159735)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.8624 15.6037L13.2042 11.9922L2.40625 22.6492C2.80772 23.0678 3.46614 23.1122 4.20484 22.7063L16.8624 15.6037Z",
    fill: "url(#paint2_linear_15481_159735)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.1953 11.9943L16.8535 8.38281L13.1953 11.9943Z",
    fill: "#097138"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.8592 8.38087L4.20484 1.2878C3.46292 0.869252 2.80451 0.926326 2.40625 1.33536L13.201 11.9924L16.8592 8.38087Z",
    fill: "url(#paint3_linear_15481_159735)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.7032 15.4648L4.20302 22.4755C3.49643 22.8718 2.89904 22.8243 2.5329 22.5325L2.41406 22.6499L2.48472 22.7196C2.88619 23.0811 3.51891 23.1033 4.2255 22.7069L16.8574 15.6139L16.7032 15.4648Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.0904 12.9988L16.7031 15.4593L16.8573 15.6115L21.0904 13.2303C21.691 12.8942 21.9961 12.4407 21.9961 12C21.948 12.409 21.6428 12.6849 21.0904 12.9988Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.20007 1.51676L21.0876 10.9911C21.64 11.305 21.9451 11.5936 21.9933 12.0026C21.9933 11.5492 21.6882 11.1084 21.0876 10.7723L4.20007 1.28529C2.98923 0.613085 2 1.16797 2 2.53776V2.66459C2 1.4692 2.98601 0.841383 4.20007 1.51676Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_15481_159735",
    x1: 12.2466,
    y1: 2.3435,
    x2: -4.91041,
    y2: 6.96506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00657,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_15481_159735",
    x1: 24.6328,
    y1: 12.0105,
    x2: 3.68082,
    y2: 12.0105,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_15481_159735",
    x1: 14.8671,
    y1: 13.9596,
    x2: 1.33427,
    y2: 37.0391,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_15481_159735",
    x1: -0.306335,
    y1: -4.95421,
    x2: 5.73723,
    y2: 5.3522,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0685,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4762,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8009,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDnIconGoogle);
export default __webpack_public_path__ + "static/media/dn_icon_google.10242f421ff098c2c2acb03072ac8417.svg";
export { ForwardRef as ReactComponent };